
import Cookies from "js-cookie";
import xlsx from "json-as-xlsx"
import React from "react";
import * as CryptoJS from 'crypto-js';
import { survey_image_base_url } from "./urls";
import { API_RESPONSE_CODE, BANK_EMPLOYEE, DATE_FORMAT, OTHER, SORT_ORDER } from "./consts";
import { differenceInCalendarDays, format, set } from "date-fns";
const _ = require("lodash");
const Key_IV = "79994A6EF73DA76C";
const PASSWORD = "EF737CC29DAE7C80644A5B01544CBA61";
const SALT = "12345";
const currentYear = new Date().getFullYear();


export function firstLetterCapital(str) {
    return str[0].toUpperCase() + str.slice(1);
}
// Create the years array dynamically from 2010 to the current year
export const generateYears = (startYear) => {
const years = [];
for (let year = startYear; year <= currentYear; year++) {
    years.push({ label: year.toString(), value: year.toString() });
}
return years;
};
export function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
           var pair = vars[i].split("=");
    if(pair[0] == variable){
      return pair[1]}
    }
    return(false);
}
export const setCookieValue = (key, value) => {
  Cookies.set(key, value, { expires: 1, path: "/" }); 
}
export const getCookieValue = (value) => {
  const keyValue = Cookies.get(value)
  if(keyValue){
    var decrypted = CryptoJS.AES.decrypt(keyValue, 'Kshema@123');
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
  }else{
    return null
  }
}
export const encryptValue = (value) => {
   return value ? CryptoJS.AES.encrypt(value, 'Kshema@123').toString() : null
}
export const removeCookieValue = (key) => {
  Cookies.remove(key)
  removeFromLocalStorage(key)
}
export const mockMobileNumber = (number) => {
  let symbol = ""
  if(number){
    if((number.length - 4) === 6){
      symbol = "XXXXXX";
    }else if((number.length - 4) === 10){
      symbol = "XXXXXXXXXX";
    }
    symbol += number.toString().substring(6,10)
  }
  return symbol;
  
}
export const getPathName = (location) => {
  return location?.pathname?.split("/")[location?.pathname?.split("/").length - 1]
}
export const titleCase = (text) => {
  return text ? _.startCase(text.toLowerCase()) : ""
}
export const mobileNumberValidation = (event) => {
  if(event.keyCode == 8 || event.keyCode == 46)             
    return true;                                         
  if(event.keyCode >= 96 && event.keyCode <= 105)           
      return true;                                          
  if(isNaN(parseInt(String.fromCharCode(event.keyCode),10)))
    return false;   
}
export const jsonParse = (data) => {
  try{
    return data ? JSON.parse(data.replace(/'/g,'"')) : ""
  }catch(e){
    return ""
  }
}
export const backPage = () => {
   window.history.back()
}
export const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <img src="/kshemaImages/three_dot.jpg" height="17px" alt='' widht="auto" className='pointer'/>
  </a>
));

export const keyPressAlphanumeric = (event) => {
  var inp = String.fromCharCode(event.keyCode);
  if (/[a-zA-Z0-9 ]/.test(inp)) {
      return true;
  } else {
      event.preventDefault();
      return false;
  }
}
export const encoder = (str) => {
  //let encoder = new TextEncoder();
  //let byteArray = encoder.encode(str)
  return CryptoJS.enc.Utf8.parse(str)
}
export const toWordArray = (str) => {
  return CryptoJS.enc.Utf8.parse(str);
}
export const encrypt = (value) => {
  var key = CryptoJS.PBKDF2(PASSWORD, SALT, {
      keySize: 128 / 32,
      iterations: 65536
  })
  var encrypted = CryptoJS.AES.encrypt(encoder(value), key, {
      iv: toWordArray(Key_IV),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

export const decrypt = (value) => {
  var key = CryptoJS.PBKDF2(PASSWORD, SALT, {
      keySize: 128 / 32,
      iterations: 65536
  })
  var decrypted = CryptoJS.AES.decrypt(value, key, {
      iv: toWordArray(Key_IV),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
  })
  return decrypted.toString(CryptoJS.enc.Utf8);
}
export const utilsHeader = () => {
  return {
    headers: {
      'Authorization': `Bearer ${Cookies.get("token")}`,
  }
  }
}
export const getChannelName = (channelID) => {
  const lists = [
    { channel_name: "CMS", channel_id: 1 },
    { channel_name: "iAgri", channel_id: 2 },
    { channel_name: "TollFreeNumber", channel_id: 3 },
    { channel_name: "FrontDesk", channel_id: 4 },
    { channel_name: "PublicLink", channel_id: 5 },
    { channel_name: "SocialMedia", channel_id: 6 },
    { channel_name: "QRCode", channel_id: 7 },
    { channel_name: "WhatsApp", channel_id: 8 },
    { channel_name: "SMS", channel_id: 9 },
    { channel_name: "Email", channel_id: 10 },
    { channel_name: "GovernmentPortal", channel_id: 11 },
    { channel_name: "NOC", channel_id: 12 },
    { channel_name: "Kiosk", channel_id: 13 },
]
  const selectedOption = lists.find(
      (option) => Number(option.channel_id) === Number(channelID)
  );
  return selectedOption ? selectedOption.channel_name : 'Unknown';
};
export const clearCookieKeys = () => {
  removeCookieValue("token")
  removeCookieValue('isAuthenticated')
  removeCookieValue("roleData")
  removeCookieValue("claimDetail")
  removeCookieValue("policyDetail")
  removeCookieValue("loginUserDetail")
  removeCookieValue("CMSstatusList")
  removeCookieValue("is_omdcUser")
  removeFromLocalStorage("claimDetail")
  removeFromLocalStorage("policyDetail")
  removeFromLocalStorage("token")
  removeCookieValue("roleFunctionalities")
}
export const documentsListsForUpload = () => {
  return [
    { value: "Entire field image", label: "Entire field image" },
    { value: "Affected Area of field image", label: "Affected Area of field image" },
    { value: "Affected Area image with 2 meters away", label: "Affected Area image with 2 meters away" },
    { value: "Close up image of affected area", label: "Close up image of affected area" },
    { value: "Image with farmer inside field", label: "Image with farmer inside field" },
    { value: "Farmer Aadhar Card image", label: "Farmer Aadhar Card image" },
    { value: "Claim Survey form image", label: "Claim Survey form image" },
    { value: "Farmer bank passbook image", label: "Farmer bank passbook image" },
    { value: "Farmer land record image", label: "Farmer land record image" },
    {value: "PP Matching CM. Pics Lat Long MISMATCH", label: "PP Matching CM. Pics Lat Long MISMATCH"},
    {value:"PP NOT matching CM. Pics matching CM", label:"PP NOT matching CM. Pics matching CM"},
    {value:"PP NOT matching CM. Pics NOT matching CM", label:"PP NOT matching CM. Pics NOT matching CM"},
    {value:"No Policy Polygon. Pics NOT matching CM", label:"No Policy Polygon. Pics NOT matching CM"},
    {value:"No Policy Polygon. Pics matching CM", label:"No Policy Polygon. Pics matching CM"},
    { value: "Others", label: "Others"},
  ]
}
export const checkTimeBetweenDates = (startDate, endDate, checkDate) => {
  const now = new Date(checkDate)
  const bookingStartDate = new Date(startDate) 
  const bookingEndDate = new Date(endDate) 
  return now.getTime() > bookingStartDate.getTime() && now.getTime() < bookingEndDate.getTime()
}
export const convertSurveyImageUrl = (url) => {
  if(url){
    const splitedUrl = url.split("_")
    return splitedUrl[0]+"/"+url
  }else{
    return null
  }
}
export async function getBase64Url(url) {
  const urlSurveyImage = survey_image_base_url+convertSurveyImageUrl(url)
  const res = await fetch(urlSurveyImage);
  const data = res.json();
  return data;
}
export const saveInLocalStorage = (key,value) => {
  localStorage.setItem(key, value);
};
export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key)
};
export const getFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  return data ?? '';
};
export const getFromDecreaptLocalStorage = (key, isNotJson = false) => {
  const keyValue = getFromLocalStorage(key)
  if(keyValue){
    var decrypted = CryptoJS.AES.decrypt(keyValue, 'Kshema@123');
    return isNotJson === false ? JSON.parse(decrypted?.toString(CryptoJS.enc.Utf8)): decrypted?.toString(CryptoJS.enc.Utf8);
  }else{
    return null
  }
};
export const isAPIFailed = (fulfilled) => {
  if (
    fulfilled?.responseInformation &&
    fulfilled?.responseInformation?.responseCode === API_RESPONSE_CODE.FAIL
  ) {
    return true;
  } else {
    return false;
  }
};
export const isAPISuccess = (fulfilled) => {
  if (
    fulfilled?.responseInformation &&
    fulfilled?.responseInformation?.responseCode === API_RESPONSE_CODE.SUCCESS
  ) {
    return true;
  } else {
    return false;
  }
};
export function getFileExtension(filename) {
  return filename ? filename.substring(filename.lastIndexOf('.') + 1).toLowerCase() : null;
}
export const selectedproductName = (id, productNames) => {
  if(productNames){
      return productNames.filter(list => list.value == id)[0]
  }
}
export const selectedVendorName = (id, vendorList) => {
  if(vendorList){
      return vendorList.filter(list => list.value == id)[0]
  }
}
export const getPermissionField = (key) => {
    const permissions = getFromDecreaptLocalStorage("roleFunctionalities")
    const selectedList = permissions && permissions.length > 0 && permissions.filter(list => list.functionalityName === key) 
    if(selectedList){
      return selectedList[0]
    }else{
      return null
    }
}
const viewModeCache = {};

export const viewModeOn = (key) => {
  if (viewModeCache.hasOwnProperty(key)) {
    return viewModeCache[key];
  }

  const permissions = getFromDecreaptLocalStorage("roleFunctionalities");
  if (!permissions) return false;

  const dataObj = permissions.find(list => list.functionalityName === key);
  if (!dataObj) return false;

  const result = dataObj?.viewMode === 1;
  viewModeCache[key] = result;
  return result;
}
export const editModeOn = (key) => {
  const permissions = getFromDecreaptLocalStorage("roleFunctionalities")
  const dataObj =  permissions.find(list => list.functionalityName === key)
  if(dataObj?.editMode === 1){
    return true
  }else{
    return false
  }
}
export function validateDecimslInput(event) {
  const input = event.target;
  let value = input.value;

  // Remove any leading decimal point
  if (value.startsWith('.')) {
      value = value.substring(1);
  }

  // Only allow one decimal point
  const parts = value.split('.');
  if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
  }

  // Update the input value
  return value
}
export function validatePAN(pan) {
  // Regular expression for PAN validation
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

  if (panRegex.test(pan)) {
      return true; // Valid PAN
  } else {
      return false; // Invalid PAN
  }
}

const getContent = (array,dateArray, name) => {
  const contentObject = {}
  if(array && array?.length && dateArray && dateArray.length){
    contentObject['type'] = name;
    array.forEach((rowValue, index)=>{
      contentObject[dateArray[index].toString()] = rowValue || 0;
    })
  }else if(dateArray && dateArray.length){
    contentObject['type'] = name;
     dateArray.forEach((date, index)=>{
      contentObject[date.toString()] = 0
    })
  }
  return contentObject;
}
export const downloadNDVI = (gisSurveyId, gisSurveyData) =>{
  const datesAll = jsonParse(gisSurveyData?.jsonResponse?.dates);
  const NDMI = jsonParse(gisSurveyData?.jsonResponse?.NDMI);
  const NDVI = jsonParse(gisSurveyData?.jsonResponse?.NDVI);
  const MSAVI = jsonParse(gisSurveyData?.jsonResponse?.MSAVI); 
  const rainfall = jsonParse(gisSurveyData?.jsonResponse?.Rainfall);
  const rainfallDates = jsonParse(gisSurveyData?.jsonResponse?.Rainfall_dates) || datesAll;

   const columnsAll = [];
   const columnsIMDRainfall = [];
   const contentAll = []
   const contentIMDRainfall = []

   if( datesAll){
      columnsAll.push(
        { label: 'Type', value: 'type' }
      )
      datesAll.forEach(item=>{
        columnsAll.push(
          { label: format(new Date(item), "dd-MM-yyyy"), value: item.toString() }
        )
      })
   }
   if(rainfallDates){
      columnsIMDRainfall.push(
        { label: 'Type', value: 'type' }
      )
      rainfallDates.forEach(item=>{
        columnsIMDRainfall.push(
          { label: format(new Date(item), "dd-MM-yyyy"), value: item.toString() }
        )
      })
   }
   contentAll.push(getContent(NDMI,  datesAll, 'NDMI'));
   contentAll.push(getContent(NDVI,  datesAll, 'NDVI'));
   contentAll.push(getContent(MSAVI,  datesAll, 'MSAVI'));
   contentIMDRainfall.push(getContent(rainfall,  rainfallDates, 'IMD Rainfall(mm)'));

  let data = [
    {
      sheet: "All",
      columns: columnsAll,
      content: contentAll,
    },
    {
      sheet: "IMD Rainfall",
      columns:columnsIMDRainfall,
      content: contentIMDRainfall,
    }
  ]
  let settings = {
    fileName: gisSurveyId || 'report',
    extraLength: 3, 
    writeMode: "writeFile",
    writeOptions: {},
  }
  xlsx(data, settings);
}

function convertMultipolygonToLatLngArray(multipolygon) {
  multipolygon = multipolygon.replace("MULTIPOLYGON ((", "MULTIPOLYGON((")
  const regex = /MULTIPOLYGON\(\(\((.*?)\)\)\)/;
  const matches = multipolygon.match(regex);
  if (!matches) {
      return []
  }
   // Replace all variations of spaces around ")), ("
   let matchValue = matches[1].trim().replace(/\)\),\s*\(\(/g, ")),((");
   // Split the polygons by ")),(("
   const polygons = matchValue.split(")),((");

  const latLngArray =  [];
    polygons.forEach(polygon => {
       polygon.trim().split(",").forEach(coord => {
          const [lng, lat] = coord.trim().split(" ");
          latLngArray.push({
            lat: Number(lat),
            lng: Number(lng),
          });
      });
  });

  return latLngArray;
}

const convertPolygonToLatLngArray = (polygon) => {
  polygon = polygon.replace("POLYGON (", "POLYGON(")
  const regex = /POLYGON\(\s*\(\s*(.*?)\s*\)\s*\)/;
  const matches = polygon.match(regex);
  const latLngArray = [];

  if (matches) {
      matches[1].split(",").forEach(coord => {
          const [lng, lat] = coord.trim().split(" ");
          latLngArray.push({
            lat: Number(lat),
            lng: Number(lng),
          });
      });
  }

  return latLngArray;
}
export const getLatLngArray = (geometry) => {
  if(!geometry){
    return [];
  }
  if (geometry.startsWith('MULTIPOLYGON')) {
      return convertMultipolygonToLatLngArray(geometry);
  } else if (geometry.startsWith('POLYGON')) {
      return convertPolygonToLatLngArray(geometry);
  } else {
      return [];
  }
}

export function clearOnKeyDown(e, inputRef){
  const input = e.target.value;
  if (e.key === 'Backspace' || e.key === 'Delete') {
      if(input.indexOf('%') !== -1){
        inputRef.current.setSelectionRange(input.indexOf('%') -1, input.indexOf('%')-1);
          const newValue = input.slice(0, input.indexOf('%') - 1) + input.slice(input.indexOf('%'));
          e.target.value = newValue;
      }
  }
}

export const filterLetters = (documents, returnLetters) => {
  //this method filters the letters and attachments and will return letters if returnLetters is true else returns attachments
  // Letters -> System generated documents
  // Attachments -> attachments which are uploaded by user
  
  const ignoreFileKeys = ['PreRegRuleLog', 'PostRegRuleLog']; // there are system generated json files
  const letterKeys = ['CWP Letter', 'Repudiation Letter', 'Rejection Letter', 'Payout Letter', 'rejection', 'repudiation', 'payment']; // system generated letters
  const letters = [];
  const attachments = [];
  documents?.forEach(document => {
    if (letterKeys.includes(document?.docType)) {
      letters.push(document)
    } else if (!ignoreFileKeys.includes(document?.docType)) {
      attachments.push(document)
    }
  });
  if (returnLetters) {
    return letters;
  } else {
    return attachments
  }
}

export const seasonValues = [
    { label: "Rabi", value: "Rabi" },
    { label: "Kharif", value: "Kharif" },
  ];
export const sortList = (sortedByColumn, orderOrder, list)=>{
    if(!list){
      return [];
    }
      if(orderOrder === SORT_ORDER.ASC){
        const ascendingList = [...list].sort((a, b) =>{
          if (a[sortedByColumn] < b[sortedByColumn])
            return -1;
          if (a[sortedByColumn] > b[sortedByColumn])
            return 1;
          return 0;
        });
        return ascendingList;
      }else{
        const descendingList = [...list].sort((a, b) =>{
          if (a[sortedByColumn] > b[sortedByColumn])
            return -1;
          if (a[sortedByColumn] < b[sortedByColumn])
            return 1;
          return 0;
        });
        return descendingList;
      }
}
export const getMaxDate = () => {
  return set(new Date(), {
    year: 2099,
    month: 11,
    date: 31,
  });
};
export const CONSTANTS = {
  SEARCH_TYPE_TRANSACTION: "5",
  NO_DATA_PRESENT: "No Data Present",
  SEARCH_TYPE_POLICY_NUMBER: "1"
};

/**
 * Check entered loss reserve value is save or not with recent record for selected product.
 * @param {*} sortedList 
 * @param {*} payload 
 * @param {*} key 
 * @returns boolean
 */
export const validateValueWithEndDate = (sortedList, payload, valueKey, endDateKey, editMode)=>{
  let isAvailable = false;
  const filteredRecords = sortedList.filter(item => item.productId === payload.productId);
  const recentRecord = filteredRecords[0]; // most recent
  if(editMode){
    return isAvailable;
  }
  const diff = differenceInCalendarDays(recentRecord[endDateKey], new Date(payload[endDateKey]).getTime());
  if(diff >= 0 && Number(payload[valueKey]) === Number(recentRecord[valueKey])){
    isAvailable = true;
  }
  return isAvailable;
}

  /**
   * Check start date validation. this method checks whether the start date overlaps with previous record start date
   * @returns boolean
   */

  export const validateStartDate = (sortedList, payload, startDateKey, endDateKey, editMode) => {
    const validatedData = { isAvailable: false };
    const filteredRecords = sortedList.filter(item => item.productId === payload.productId);
  
    const payloadStartDate = new Date(payload[startDateKey]);
    const payloadEndDate = new Date(payload[endDateKey]);

    const formattedStart = format(payloadStartDate, DATE_FORMAT.DD_MM_YYYY);
    const formattedEnd = format(payloadEndDate, DATE_FORMAT.DD_MM_YYYY);
  
    const recentRecord = filteredRecords[0]; // most recent
    if (!recentRecord) return validatedData;
    // find previous and next record
    let previousRecord = null;
    let nextRecord = null;
    for(let index = 0; index < filteredRecords.length; index++){
      if(filteredRecords[index].slno === payload.slno){
        if(filteredRecords[index-1]){
          nextRecord = filteredRecords[index-1]
        }
        if(filteredRecords[index+1]){
          previousRecord = filteredRecords[index+1]
        }
        break;
      }
    }
    
    
    const recentStartDate = new Date(recentRecord[startDateKey]);
    const recentEndDate = new Date(recentRecord[endDateKey]);
  
    const formattedRecentStart = format(recentStartDate, DATE_FORMAT.DD_MM_YYYY);
    const formattedRecentEnd = format(recentEndDate, DATE_FORMAT.DD_MM_YYYY);
    let nextEndDate;
    let formattedNextEnd;
    let nextStartDate;
    let formattedNextStart;
    if(nextRecord){
      nextEndDate = new Date(nextRecord[endDateKey]);
      formattedNextEnd = format(nextEndDate, DATE_FORMAT.DD_MM_YYYY);
      nextStartDate = new Date(nextRecord[startDateKey]);
      formattedNextStart = format(nextStartDate, DATE_FORMAT.DD_MM_YYYY);
    }
    
    if (editMode) {
      const isFirstRecord = ( !previousRecord && nextRecord) ? true : false;
      if (recentRecord.slno === payload.slno &&   differenceInCalendarDays(payloadStartDate, recentStartDate) < 0 && filteredRecords.length > 0) {
        return {
          isAvailable: true,
          message: `Start date could not be less than ${formattedRecentStart}`
        };
      }
      if (isFirstRecord && recentRecord.slno !== payload.slno && differenceInCalendarDays(payloadStartDate, nextStartDate) >= 0) {
        return {
          isAvailable: true,
          message: `Start date must be before ${formattedNextStart}`
        };
      }
      if (isFirstRecord && recentRecord.slno !== payload.slno && differenceInCalendarDays(payloadEndDate, nextStartDate) >= 0) {
        return {
          isAvailable: true,
          message: `End date must be before ${formattedNextStart}`
        };
      }
      if(previousRecord){
        let previousStartDate = new Date(previousRecord[startDateKey]);
        let previousEndDate = new Date(previousRecord[endDateKey]);
        const formattedPreviousEnd = format(previousEndDate, DATE_FORMAT.DD_MM_YYYY);
        const formattedPreviousStart = format(previousStartDate, DATE_FORMAT.DD_MM_YYYY);
        if(differenceInCalendarDays(payloadStartDate, previousEndDate) > 1){
          return {
            isAvailable: true,
            message: `No gap allowed between ${formattedPreviousEnd} and ${formattedStart}`
          };
        }
        if(differenceInCalendarDays(previousEndDate, payloadStartDate) >= 0 ){
          return {
            isAvailable: true,
            message: `${formattedStart} cannot be less than or equal to  ${formattedPreviousEnd} `
          };
        }
        if(differenceInCalendarDays(previousStartDate, payloadEndDate) > 1){
          return {
            isAvailable: true,
            message: `No gap allowed between ${formattedPreviousStart} and ${formattedStart}`
          };
        }
      }
      if(nextRecord){
        if(differenceInCalendarDays(payloadStartDate, nextEndDate) >= 0){
          return {
            isAvailable: true,
            message: `${formattedStart} cannot be greater than or equal to ${formattedNextEnd}`
          };
          
        }
        
        if(differenceInCalendarDays(payloadEndDate, nextStartDate) >= 0){
          return {
            isAvailable: true,
            message: `${formattedEnd} cannot be greater than or equal to ${formattedNextStart}`
          };
          
        }
        if(differenceInCalendarDays(payloadStartDate, nextStartDate) >= 0){
          return {
            isAvailable: true,
            message: `${formattedStart} cannot be greater than to equal to ${formattedNextStart}`
          };
          
        }
        if(differenceInCalendarDays(nextStartDate, payloadEndDate) > 1){
          return {
            isAvailable: true,
            message: `Date gap not allowed between ${formattedEnd} and ${formattedNextStart}`
          };
          
        }
      }

    }
  
    if (!editMode) {
      const startTooEarly = (
        differenceInCalendarDays(payloadStartDate, recentStartDate) <= 0 
      );
      if (startTooEarly) {
        return {
          isAvailable: true,
          message: `Start date must be after ${formattedRecentStart}`
        };
      }
    }
  
    if (differenceInCalendarDays(payloadEndDate, payloadStartDate) <= 0) {
      return {
        isAvailable: true,
        message: 'End date must be greater than start date'
      };
    }
  
    return validatedData;
  };
  
export const validateEmail = (email) => {
  // Regular expression for basic email validation
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i;
  return emailRegex.test(email);
}

export const DECIMAL_NUMBER_REGEX =/^\d*\.?\d{0,2}$/;

export const sanitizeInput = (inputValue) => {
  // Remove any non-numeric characters except the decimal point
  inputValue = inputValue.replace(/[^0-9.]/g, '');

  // Split the input value into integer and decimal parts
  const [integerPart, decimalPart] = inputValue.split('.');

  // Limit the integer part to 9 characters
  if (integerPart.length > 9) {
      return integerPart.slice(0, 9);
  } else if (decimalPart && integerPart.length <= 9) {
      // If there's a decimal part and the integer part is within the limit, include the decimal part
      return `${integerPart}.${decimalPart}`;
  }

  return inputValue;
};

export const isOtherIntimatorInfoMissing = (claimIntimatedBy, intimatorName, relationship) => {
  return (
    claimIntimatedBy === OTHER ?
    (!intimatorName?.trim() || !relationship) : (claimIntimatedBy === BANK_EMPLOYEE  && !intimatorName?.trim())
  );
};

export const formattedNumber = (num) => {
  const [integerPart, decimalPart] = num.toString().split(".");

  let lastThree = integerPart.slice(-3);
  let otherNumbers = integerPart.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  const formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

export const getFileExtensionType = (fileName) => {
  if (!fileName) return '';
  const parts = fileName.split('.');
  if (parts.length > 1) {
    const extension = parts.pop().toLowerCase();

    if (extension === 'pdf') {
      return 'PDF';
    }

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(extension)) {
      return 'jpg'; // Standardize image types to 'jpg'
    }

    if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
      return 'mp4'; // Add support for video types
    }
  }
  return ''; // Default or unknown type
};

  
export const scrollToTop = () => {
  const container = document.getElementById("scrollable-container");
  if (container) {
    container.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } else {
    console.warn("Scrollable container not found");
  }
};

export const formatDocumentDetails = (documentDetails = []) => {
  return documentDetails.map((doc, index) => ({
    id: doc.documentId,
    docName: `Document ${index + 1}`,
    docURL: doc.documentUrl,
    fileType: doc.documentType, // 'pdf', 'image', 'video', or 'other'
    referenceId:doc.referenceId
  }));
};

export const areAllAnswersFilled = (
  questions,
  showAffectedDaysField,
  showAdditionalQuestion
) => {
  if (showAdditionalQuestion) {
    return questions.every((item) => {
      // Skip question with qid = 2 if showAffectedDaysField is false
      if (!showAffectedDaysField && item.qid === 2) {
        return true;
      }
      // Check if questionAnswer is not empty, null, or undefined
      return (
        item.questionAnswer !== null &&
        item.questionAnswer !== undefined &&
        item.questionAnswer !== ""
      );
    });
  } else return true;
};

export const groupDocumentsByType = (documents = []) => {     //Group documents by type
    return documents.reduce((acc, doc) => {
        acc[doc.type] = acc[doc.type] || [];
        acc[doc.type].push(doc);
        return acc;
    }, {});
};

export const getFlagName = (flags) => {
  if (!Array.isArray(flags) || flags.length === 0) return "--";
  const flagMap = {
    1: "Fraud",
    2: "Potential Litigation",
    3: "Litigation",
    4: "Suspicious",
  };
  const displayFlags = flags
    .map((flag) => flagMap[flag.flagId])
    .filter(Boolean);
  return displayFlags.length > 0 ? displayFlags.join(", ") : "--";
};
